module.exports = __webpack_public_path__ + "static/media/recorridoKids.4cf5fc7b.webp";